import React, { useState, useRef } from "react";
import Backdrop from "@material-ui/core/Backdrop";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import { useDispatch, useSelector } from "react-redux";
import Fade from "@material-ui/core/Fade";
import { Typography } from "@material-ui/core";
import { setInterestsOpen } from "../redux/actions/index";
import { fetchAllContent } from "../redux/dataFetchers/contentApi";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  typography: {
    textAlign: "center",
    fontSize: "small",
    marginBottom: "1rem",
  },
  interest: {
    margin: "0.3rem",
  },
}));

const interests = [
  "HR",
  "Recruitment",
  "Tech",
  "AI/ML",
  "Coding",
  "Data Science",
  "Cloud",
  "IT",
  "Hiring",
];

export default function FeedInterest() {
  const reduxState = useSelector((state) => state);
  const dispatch = useDispatch();
  const classes = useStyles();

  const [selectedInterests, setSelectedInterests] = useState([]);
  const interestsRef = useRef([]);

  const closeInterests = () => {
    dispatch(setInterestsOpen(false));
  };

  const saveInterests = () => {
    const finalInterests = [];
    let uniqueIndexes = Array.from(new Set(selectedInterests));
    //set interests
    for (let i = 0; i < selectedInterests.length; i++) {
      finalInterests.push(interests[uniqueIndexes[i]]);
    }

    if(finalInterests.length === 0)
      return Swal.fire({
        icon:'info',
        title:"Please select interest!",
        timer:2500,
      })
    console.log(finalInterests);
    const token = localStorage.getItem("token");
    //save interests
    fetch(`https://recruitingmonk-v2.azurewebsites.net/interests/${reduxState.info.info.uid}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        interests: finalInterests,
      }),
    })
      .then((response) => {
        if (response.ok) {
          console.log(response);
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          console.log("interests saved successfully");
          dispatch(fetchAllContent());
          dispatch(setInterestsOpen(false));
          return;
        }
        throw new Error(response)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const interestSelected = (pos) => {
    console.log(selectedInterests);

    // de-select interest if already selected
    if (interestsRef.current[pos].style.background) {
      interestsRef.current[pos].style.background = "";
      interestsRef.current[pos].style.color = "black";
      return setSelectedInterests((prevSelectedInterests) => {
        prevSelectedInterests.pop(Number(pos));
        return prevSelectedInterests;
      });
    }

    //select interest
    interestsRef.current[pos].style.background = "#B0343C";
    interestsRef.current[pos].style.color = "white";
    setSelectedInterests((prevSelectedInterests) => {
      prevSelectedInterests.push(Number(pos));
      return prevSelectedInterests;
    });
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={reduxState.info.interests.isInterestsOpen}
        // onClose={closeInterests}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade
          in={reduxState.info.interests.isInterestsOpen}
          className="flex flex-col items-center p-4 w-5/6 md:w-1/3"
        >
          <div
            className="px-6"
            style={{
              backgroundColor: "rgb(209, 192, 179)",
              borderRadius: "5px",
            }}
          >
            <div
              className="flex flex-col items-center gap-3 w-full"
              id="transition-modal-title"
            >
              <h3 style={{ fontWeight: "bold" }}>INTERESTS</h3>
              <Typography className={classes.typography}>
                Add your interests so we can begin to personalize your
                feed.Interests are private to you.
              </Typography>
              <div>
                {interests.map((interest, pos) => {
                  return (
                    <Button
                    key={interest}
                      className={classes.interest}
                      ref={(el) => (interestsRef.current[pos] = el)}
                      style={{
                        fontWeight: "bold",
                      }}
                      variant={"contained"}
                      onClick={() => interestSelected(pos)}
                    >
                      {interest}
                    </Button>
                  );
                })}
              </div>
              <div>
                <Button
                  className={classes.interest}
                  style={{
                    fontWeight: "bold",
                    color: "#464545",
                  }}
                  variant={"outline"}
                  onClick={saveInterests}
                >
                  Submit
                </Button>
                <Button
                  className={classes.interest}
                  style={{
                    fontWeight: "bold",
                    color: "#464545",
                  }}
                  variant={"outline"}
                  onClick={closeInterests}
                >
                  Skip
                </Button>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
